import React from "react";

import { faCoinBlank, faTimer } from "@fortawesome/pro-regular-svg-icons";

import { Pill } from "src/base-components/Pill";
import { formatDuration } from "src/utils/numbers";

export const formatTokenCount = (count: number): string =>
  new Intl.NumberFormat("en-US", {
    notation: "compact",
    compactDisplay: "short",
    maximumFractionDigits: 1,
  })
    .format(count)
    .toLowerCase();

export const DurationPill: React.FC<{ durationMs: number }> = ({
  durationMs,
}) => (
  <Pill size="sm" variant="gray">
    <Pill.Icon icon={faTimer} />
    <Pill.Text>{formatDuration(durationMs)}</Pill.Text>
  </Pill>
);

export const TokensPill: React.FC<{ count: number }> = ({ count }) => (
  <Pill size="sm" variant="gray">
    <Pill.Icon icon={faCoinBlank} />
    <Pill.Text>{formatTokenCount(count)}</Pill.Text>
  </Pill>
);
